/**
 * ReviewCard - one piece of feedback someone left.
 */

import { Link } from 'react-router-dom';

import Avatar from './Avatar';
import StarRating from './StarRating';
import { timeAgo, displayName, isDeleted } from '../utils/format';

export default function ReviewCard({ review }) {
  const author = review.author;

  return (
    <div className="review">
      <div className="review-header">
        <Avatar person={author} size="sm" />

        <div style={{ flex: 1, minWidth: 0 }}>
          <div className="row" style={{ gap: 'var(--space-xs)' }}>
            {/* A closed account keeps its review, but has no profile left to
                link to - so show the name as plain text instead. */}
            {author && !isDeleted(author) ? (
              <Link
                to={`/${author.role === 'student' ? 'students' : 'users'}/${author._id}`}
                className="font-semibold"
              >
                {displayName(author)}
              </Link>
            ) : (
              <span className="font-semibold text-muted">{displayName(author)}</span>
            )}
            <StarRating value={review.rating} size={14} />
          </div>

          <div className="text-sm text-muted">
            {timeAgo(review.createdAt)}
            {review.chore?.title && (
              <>
                {' · '}
                <span>{review.chore.title}</span>
              </>
            )}
          </div>
        </div>
      </div>

      {review.comment && <p className="review-comment">{review.comment}</p>}
    </div>
  );
}
